var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContactStats'),_c('ContactList',{attrs:{"search-query":this.$route.query.q}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }